module.exports = __webpack_public_path__ + "static/media/magnitProduct.8a69f4a7.jpeg";